import React from 'react';
import { cn } from '../../utils/cn';
import { motion } from 'framer-motion';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onChange,
  className
}: TabsProps) {
  return <div className={cn('flex space-x-1 rounded-lg bg-gray-900/50 p-1', className)} data-id="element-404">
      {tabs.map(tab => <button key={tab.id} onClick={() => onChange(tab.id)} className={cn('relative flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500', activeTab === tab.id ? 'text-white' : 'text-gray-400 hover:text-gray-200')} data-id="element-405">
          {activeTab === tab.id && <motion.div layoutId="activeTab" className="absolute inset-0 rounded-md bg-gray-800 shadow-sm" transition={{
        type: 'spring',
        bounce: 0.2,
        duration: 0.6
      }} data-id="element-406" />}
          <span className="relative z-10" data-id="element-407">{tab.label}</span>
        </button>)}
    </div>;
}